import React from 'react';
import {useNavigate} from 'react-router-dom';
import {NOTIFICATIONS_HAMBURGER_SIZE_DEFAULT_VALUES} from '../../../../../constants';
import {NotificationStatus} from '../../../../../incase-domain/notification';
import useNotification from '../../../../../service/hooks/useNotification';
import Button from '../../../../../incase-domain/components/button/Button';
import Badge from '../../../../../incase-domain/components/badge/Badge';

function NotificationsHeaderItem({theme}: {theme: 'light' | 'dark'}): JSX.Element {
    const navigate = useNavigate();
    const {notifications} = useNotification(NOTIFICATIONS_HAMBURGER_SIZE_DEFAULT_VALUES, [NotificationStatus.ACTIVE]);

    return (
        <Badge value={notifications.data?.numberOfUnseen} color={theme}>
            <Button
                leading="solar:bell-linear"
                color={theme === 'light' ? 'basic' : 'primary'}
                size="md"
                className="c-header__actions_icon"
                variant="ghost"
                square
                onClick={() => {
                    navigate('/notifications');
                }}
            />
        </Badge>
    );
}

export default NotificationsHeaderItem;
